import {management} from '../../../../index'
import {LogSectorRepository} from '../../../infra/knex/repositories/log_sector'

import {UpdateLogSectorByIdSector} from './updateByIdSector'

export const updateOffsetSectorByIdSector=()=>{
  const repository=new LogSectorRepository(management)

  const updateOffset= new UpdateLogSectorByIdSector(repository)

  return updateOffset
}
